import { ActivityLogMaintenanceConstant } from "presentation/constant/ActivityLog/ActivityLogMaintenanceConstant";
import { useActivityLogMaintenanceVM } from "presentation/hook/ActivityLog/useActivityLogMaintenanceVM";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ActivityLogTitleBar: React.FC = () => {
    const activityLogVM = useActivityLogMaintenanceVM();


    const handleSearch = useCallback(async () => {
        activityLogVM.onToggleCriteriaPanel();
    }, [activityLogVM]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{ActivityLogMaintenanceConstant.TITLE}</HeaderTitle>
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
        </StyledAction>
    </Sidebarheader>
}

export default memo(ActivityLogTitleBar);